import { render, staticRenderFns } from "./Type1b.vue?vue&type=template&id=7468df57&"
import script from "./Type1b.vue?vue&type=script&lang=js&"
export * from "./Type1b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports